import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, user, isLoading, isBanned } = useSelector((state) => state.auth);
  const [isInitializing, setIsInitializing] = useState(true);

  // Проверяем наличие токена в localStorage и ждем восстановления состояния
  useEffect(() => {
    // При первом рендере проверяем, есть ли токен
    const token = localStorage.getItem('token');
    
    if (token) {
      // Если токен есть, но isAuthenticated еще false, даем время на восстановление
      // Redux store восстанавливает состояние синхронно, но может быть небольшая задержка
      if (!isAuthenticated && !isLoading) {
        // Проверяем еще раз через небольшой интервал
        const timer = setTimeout(() => {
          setIsInitializing(false);
        }, 200);
        return () => clearTimeout(timer);
      } else {
        // Если isAuthenticated уже true или isLoading true, ждем завершения загрузки
        if (!isLoading) {
          setIsInitializing(false);
        }
      }
    } else {
      // Нет токена - сразу готовы к редиректу
      setIsInitializing(false);
    }
  }, [isAuthenticated, isLoading]);

  // Пока инициализируемся или загружается аутентификация, показываем индикатор загрузки
  // Это предотвращает мелькание редиректа на /login при hard refresh
  if (isLoading || isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Загрузка...</p>
        </div>
      </div>
    );
  }

  // Если пользователь забанен, не редиректим - показываем модальное окно
  // Модальное окно в App.js обработает это и разлогинит пользователя при нажатии кнопки
  if (isBanned) {
    // Показываем детей, чтобы модальное окно могло отобразиться
    return children;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;